import { render, staticRenderFns } from "./OpSelectDepartment.vue?vue&type=template&id=051651f8&"
import script from "./OpSelectDepartment.vue?vue&type=script&lang=js&"
export * from "./OpSelectDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports